export const pricePlans = [
  {
    name: "少量プラン",
    size: "家具1・2点など",
    price: "5,500",
    note: "小さな不用品から",
    icon: "ri-archive-2-line",
    featured: false,
  },
  {
    name: "軽トラック相当",
    size: "目安：軽トラ1台分",
    price: "15,000",
    note: "一人暮らしの片付けなど",
    icon: "ri-truck-line",
    featured: true,
  },
  {
    name: "1tトラック相当",
    size: "目安：1tトラック1台分",
    price: "30,000",
    note: "まとまった量の片付け",
    icon: "ri-truck-line",
    featured: false,
  },
  {
    name: "2tトラック相当",
    size: "目安：2tトラック1台分",
    price: "50,000",
    note: "一軒家・大量の荷物",
    icon: "ri-truck-line",
    featured: false,
  },
];

export const priceNotes = [
  "上記はあくまで目安料金です。",
  "荷物の種類・量・搬出状況・階段作業・スタッフ人数などにより変動します。",
  "正式な金額は現地確認・お見積もり後にご提示します。",
  "遺品整理・一軒家丸ごとの片付けは、現地調査のうえ個別にお見積もりします。",
];